import { c as e } from "../../../../index.esm-BeDSGXP5.js";
import { css as l } from "styled-components";
const i = {
  base: ({ theme: o }) => /* @__PURE__ */ l([
    "font:inherit;color:inherit;text-decoration:underline;",
    " cursor:pointer;",
    " &:hover{text-decoration:none;}"
  ], e({
    fontWeight: "medium"
  }), o.components.forms.focusActiveState),
  small: () => /* @__PURE__ */ l([
    "",
    ""
  ], e({
    fontSize: [
      "textSmallMobile",
      null,
      "textSmallDesktop"
    ],
    lineHeight: [
      "textSmallMobile",
      null,
      "textSmallDesktop"
    ]
  })),
  medium: () => /* @__PURE__ */ l([
    "",
    ""
  ], e({
    fontSize: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    lineHeight: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ]
  })),
  large: () => /* @__PURE__ */ l([
    "",
    ""
  ], e({
    fontSize: [
      "textLargeMobile",
      null,
      "textLargeDesktop"
    ],
    lineHeight: [
      "textLargeMobile",
      null,
      "textLargeDesktop"
    ]
  })),
  dark: ({ theme: o }) => /* @__PURE__ */ l([
    "color:",
    ";svg{color:",
    ";}&:hover{color:",
    ";svg{color:",
    ";}}"
  ], o.componentColors.link.dark, o.componentColors.link.darkIcon, o.componentColors.link.darkHover, o.componentColors.link.darkIconHover),
  light: ({ theme: o }) => /* @__PURE__ */ l([
    "color:",
    ";svg{color:",
    ";}&:hover{color:",
    ";svg{color:",
    ";}}"
  ], o.componentColors.link.light, o.componentColors.link.lightIcon, o.componentColors.link.lightHover, o.componentColors.link.lightIconHover),
  newTabIcon: () => /* @__PURE__ */ l([
    "vertical-align:middle;margin-left:5px;margin-top:-3px;"
  ])
};
export {
  i as default
};
